import React from 'react'
import SewingRepairInBatchHeader from './SewingRepairInBatchTable/SewingRepairInBatchHeader'
import SewingRepairInBatchRow from './SewingRepairInBatchTable/SewingRepairInBatchRow'

function SewingRepairInBatchTable(props) {
    const { listSewingRepair, loading, setType, setBrand } = props

    return (
        <div className='SewingRepairInBatchTable'>
            <table className='table table-borderless table-striped'>
                <SewingRepairInBatchHeader />
                <tbody className='SewingRepairRow'>
                    {
                        !!listSewingRepair && listSewingRepair.map((item, i) => {
                            return <SewingRepairInBatchRow
                                key={item._id}
                                index={i}
                                item={item}
                                setType={setType}
                                setBrand={setBrand}
                            />
                        })
                    }
                    {
                        !loading && listSewingRepair.length === 0 &&
                        <tr>
                            <td colSpan={9}>
                                No result
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default SewingRepairInBatchTable